import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const HomeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Home",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.39 16.53v12.31h-7.12V21.5c0-.36-.29-.66-.65-.67h-4.89c-.36 0-.66.29-.67.65v7.36H5.94V16.53l9.9-8.78c.2-.17.49-.17.68 0l9.86 8.78Zm3.24-.24c-.53.48-.89.51-1.4.07-.28-.24-9.59-8.65-12.03-10.86C13.61 7.78 4.26 15.98 3.83 16.33c-.38.38-.99.38-1.36 0-.03-.03-.06-.06-.08-.09-.52-.49-.51-.83.1-1.4L15.52 3.42c.38-.35.96-.35 1.34 0l3.83 3.45V5.44c.01-.13.12-.23.25-.22h2.64c.13 0 .24.09.25.22v4.34l5.64 5.1c.7.65.66.93.16 1.4Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.86 30.57H19c-.63 0-1.14-.51-1.14-1.14v-8h-4.57v8c0 .63-.51 1.14-1.14 1.14H5.29c-.63 0-1.14-.51-1.14-1.14V18a1.14 1.14 0 1 1 2.28 0v10.29H11v-8c0-.63.51-1.14 1.14-1.14H19c.63 0 1.14.51 1.14 1.14v8h4.57V18a1.14 1.14 0 1 1 2.28 0v11.43c0 .63-.51 1.14-1.14 1.14ZM28.14 15.71c-.29 0-.58-.11-.81-.33L15.57 3.62 3.81 15.38c-.45.45-1.17.45-1.62 0a1.14 1.14 0 0 1 0-1.62L14.76 1.19c.43-.43 1.19-.43 1.62 0l12.57 12.57a1.14 1.14 0 0 1-.81 1.95"
      })
    })
  }));
};